module.exports = __webpack_public_path__ + "static/media/soul-back.1edece3d.svg";